import { Icon, IconButton, Link } from "@chakra-ui/react";
import type { ElementType } from "react";

interface SocialButtonProps {
	icon: ElementType;
	label: string;
	link: string;
}

export const SocialButton = (props: SocialButtonProps) => {
	const { icon, link, label } = props;
	return (
		<IconButton
			size="sm"
			as={Link}
			isExternal
			textAlign="center"
			variant="unstyled"
			aria-label={label}
			icon={<Icon as={icon} />}
			fontSize={{ base: "xl", md: "2xl" }}
			_hover={{ color: "brand.contrast" }}
			href={link}
		/>
	);
};
